<template>
  <div class="root-container">
    <div class="menu-wrap">
      <div class="right">
        <div class="logo-wrap">
          <img src="../../../assets/images/logo.png" alt="" />
        </div>
        <div class="text">
          <span> 广州科明数字是一家专注于教育信息化与数字校园建设的科技企业致力于以创新技术赋能教学与管理，帮助学校实现数字化转型，提升教育质量与运营效率。 </span>
        </div>
        <div style="margin-top: 10px; margin-left: 16px; display: flex; align-items: center;">
          <el-popover placement="top" width="150px" trigger="hover">
            <img src="../../../assets/images/16c087a07b99cd2402011c0b4f076258.jpg" alt="" style="width: 150px;">
            <img slot="reference" src="../../../assets/images/02微信公众号.png" alt="" style="width: 24px; margin-right: 10px; cursor: pointer;">
          </el-popover>
          <el-popover placement="top" width="200px" trigger="hover">
            <img src="../../../assets/images/b467172239b8e24f1d357cbd2f1135a3.jpg" alt="" style="width: 200px;">
            <img slot="reference" src="../../../assets/images/抖音.png" alt="" style="width: 20.5px; margin-right: 10px; cursor: pointer;">
          </el-popover>
          <!-- <el-popover placement="top" width="150px" trigger="hover">
            <img src="../../../assets/images/ma.png" alt="" style="width: 150px;">
            <img slot="reference" src="../../../assets/images/B站.png" alt="" style="width: 20.5px; margin-right: 10px; cursor: pointer;">
          </el-popover> -->
          <el-popover placement="top" width="150px" trigger="hover">
            <img src="../../../assets/images/07ff11518946b32bff59671b6665cff2.jpg" alt="" style="width: 150px;">
            <img slot="reference" src="../../../assets/images/视频号.png" alt="" style="width: 24px; margin-right: 10px; cursor: pointer;">
          </el-popover>
        </div>
      </div>
      <div class="left">
        <div class="item">
          <span class="title">公司</span>
          <span class="sub-title">关于我们</span>
          <span class="sub-title">企业文化</span>
          <span class="sub-title">团队介绍</span>
          <span class="sub-title">新闻动态</span>
        </div>
        <div class="item">
          <span class="title">产品</span>
          <span class="sub-title">产品系列</span>
          <span class="sub-title">解决方案</span>
          <span class="sub-title">技术支持</span>
          <span class="sub-title">合作伙伴</span>
          <span class="sub-title">案例展示</span>
        </div>
        <div class="item">
          <span class="title">资源</span>
          <span class="sub-title">资源中心</span>
          <span class="sub-title">帮助文档</span>
          <span class="sub-title">API文档</span>
          <span class="sub-title">常见问题</span>
        </div>
        <div class="item">
          <span class="title">法律</span>
          <span class="sub-title">隐私政策</span>
          <span class="sub-title">服务条款</span>
          <span class="sub-title">法律声明</span>
          <span class="sub-title">Cookie政策</span>
        </div>
      </div>
    </div>
    <div class="company-info">
      <div class="info-item">
        <div class="icons">
          <svg t="1761791079208" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="7784" width="20" height="20">
            <path
              d="M783.552 740.864L512 1012.416l-271.552-271.552a384 384 0 1 1 543.104 0zM512 554.624A85.312 85.312 0 1 0 512 384a85.312 85.312 0 0 0 0 170.688z"
              fill="#275eff" p-id="7785"></path>
          </svg>
        </div>
        <div class="content">
          <span class="title">公司地址</span>
          <span class="text">广州市黄埔区光谱中路3号创兴港AI智谷B1栋7楼</span>
        </div>
      </div>
      <div class="info-item">
        <div class="icons">
          <svg t="1761792553773" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="11397" width="20" height="20">
            <path
              d="M751.177143 614.4c-68.754286 68.242286-68.754286 136.557714-136.777143 136.557714S477.622857 682.715429 409.6 614.4 272.822857 477.842286 272.822857 409.6s68.754286-68.242286 136.777143-136.557714S272.822857 0 204.8 0 0 204.8 0 204.8c0 136.557714 140.434286 413.330286 272.822857 546.157714S682.422857 1024 819.2 1024c0 0 204.8-136.557714 204.8-204.8s-204.8-273.042286-272.822857-204.8z"
              fill="#275eff" p-id="11398"></path>
          </svg>
        </div>
        <div class="content">
          <span class="title">联系电话</span>
          <span class="text">13794408612(陈总)</span>
        </div>
      </div>
      <div class="info-item">
        <div class="icons">
          <svg t="1761792594166" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="14221" width="20" height="20">
            <path
              d="M869.94688 333.025793L511.998465 556.74304 154.051073 333.025793v-89.487104l357.947392 223.717247L869.94688 243.537665v89.488128z m0-178.974208H154.051073c-49.243541 0-89.48608 40.243563-89.48608 89.487104v536.922622c0 49.197492 40.24254 89.487104 89.48608 89.487104H869.94688c49.244564 0 89.487104-40.289612 89.487104-89.487104V243.537665c0-49.243541-40.24254-89.48608-89.487104-89.48608z"
              p-id="14222" fill="#275eff"></path>
          </svg>
        </div>
        <div class="content">
          <span class="title">电子邮箱</span>
          <span class="text">1213570489@qq.com</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <div>
        <span>@2025 广州科明数字技术有限公司 @2024 粤ICP备2022141624号-1</span>
      </div>
      <div>
        <span style="margin-right: 30px">隐私政策</span>
        <span style="margin-right: 30px">服务条款</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
::v-deep .el-popover {
  min-width: none !important;
  min-width: 100px;
}
.root-container {
  width: 100%;
  min-width: 1600px;
  // background-color: #192335;
  background-image: url('https://minio.kemingvr.com/public/20260109150652049/a66718b8-aea8-4566-ae16-56784064d3d4.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  height: 585px;
  padding-top: 80px;
  box-sizing: border-box;

  .menu-wrap {
    width: 1600px;
    min-height: 250px;
    margin: 0 auto;
    display: flex;
    border-bottom: 1px solid #d6d9df;

    .right {
      width: 400px;

      .logo-wrap {
        width: 200px;

        img {
          width: 200px;
        }
      }

      .text {
        font-size: 15px;
        color: #333333;
        line-height: 25px;
        margin-left: 20px;
      }
    }

    .left {
      margin-left: 80px;
      display: flex;

      .item {
        display: flex;
        flex-direction: column;
        margin-right: 210px;

        .title {
          font-size: 20px;
          color: #2d80ff;
          font-weight: bolder;
          margin-bottom: 25px;
        }

        .sub-title {
          color: #4f4f4f;
          font-size: 15px;
          margin-bottom: 15px;
          &:hover {
            color: #000;
            cursor: pointer;
          }
        }
      }
    }
  }

  .company-info {
    width: 1600px;
    margin: 0 auto;
    padding: 40px 0;
    border-bottom: 1px solid #d6d9df;
    display: flex;

    .info-item {
      display: flex;
      height: 45px;
      align-items: center;
      flex: 1;

      .icons {
        width: 40px;
        height: 40px;
        border-radius: 6px;
        background-color: #fff;
        text-align: center;
        line-height: 40px;
        margin-right: 10px;
      }

      .content {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .title {
          color: #4f4f4f;
          font-size: 16px;
          text-align: justify;
          font-family: Roboto-regular;
          font-weight: bolder;
        }

        .text {
          color: rgba(156, 163, 176, 1);
          font-size: 14px;
          text-align: justify;
          font-family: Roboto-regular;
        }
      }
    }
  }

  .footer {
    width: 1600px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    height: 120px;
    line-height: 120px;
    font-size: 15px;
    color: #4f4f4f;
  }
}
</style>
